import SrProcess from "./index.vue";

SrProcess.install = function(Vue) {
  Vue.component(SrProcess.name, SrProcess);
};

export default SrProcess;



// WEBPACK FOOTER //
// ./packages/SrProcess/index.js